export default "__VITE_ASSET__jcLmKJGU__"